module.exports = __webpack_public_path__ + "static/media/packet_3.a16c2233.png";